$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
template = require 'app/scripts/views/templates/header_enterprise_notification'
Util = require 'app/scripts/lib/util'

module.exports = class EnterpriseNotificationBannerView extends WarningBannerView
  className: ->
    "header-banner mod-warning enterprise-notification-banner #{@model.oneTimeMessageId}"

  events:
    'click .js-dismiss-enterprise-notification-banner': 'dismiss'

  render: ->
    data =
      enterpriseName: @model.displayName
      formattedMessage: @model.message
      oneTimeMessageId: @model.oneTimeMessageId

    @$el.html template(data)

    @

  dismiss: (e) ->
    Auth.me().dismiss(@model.oneTimeMessageId)
    $(e.target).closest('.enterprise-notification-banner').remove()
    e.preventDefault()
